/**
 * 将请求 URL 收成「在干嘛」的稳定 key（去掉 query / 动态 id，避免轮询打爆维度）。
 * @param {string} [method]
 * @param {string} [url]
 * @returns {string}
 */
export function normalizeAnalyticsApiKey(method, url) {
  const m = String(method || 'GET')
    .trim()
    .toUpperCase() || 'GET';
  let path = String(url ?? '').trim();
  if (!path) return m;

  if (/^https?:\/\//i.test(path)) {
    try {
      path = new URL(path).pathname;
    } catch {
      /* keep path */
    }
  }

  const q = path.indexOf('?');
  if (q >= 0) path = path.slice(0, q);
  const h = path.indexOf('#');
  if (h >= 0) path = path.slice(0, h);

  // /app 前缀在不同环境可能有无，统计侧去掉便于对齐
  if (path.startsWith('/app/')) path = path.slice(4);

  path = path
    .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '/:id')
    .replace(/\/(?:0x)?[0-9a-f]{24,}(?=\/|$)/gi, '/:id')
    .replace(/\/\d+(?=\/|$)/g, '/:id')
    .replace(/(\/order\/depth\/)[^/]+/i, '$1:id')
    .replace(/(\/follows\/)[^/]+/i, '$1:id')
    .replace(/(\/collection\/(?:get|detail)\/)[^/]+/i, '$1:id');

  return `${m} ${path || '/'}`;
}
